import React from "react";
import "./index.scss";
import {
  SET_ZIP_FILE_DOWNLOAD_NAME,
  TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP,
} from "./reducers/document-management-reducer";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import { Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/validator";
import MdaeTextBox from "../../common_components/common_widgets/text-box";
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch } from "react-redux";
const ZipFileDonwloaConfirmPopup: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  return (
    <MdaePopup
      mdaeTitleRender={() => {
        return (
          <MdaePopupTitle
            closePopupHandler={false}
            isSmallPopup={true}
            isHideCloseButton={true}
          >
            Confirm
          </MdaePopupTitle>
        );
      }}
      className="wait-time-modal"
      width={400}
      height={200}
      showTitle={true}
      deferRendering={false}
      hideOnOutsideClick={false}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP,
          reducerName: "documentManagementReducer",
          widgetOptionBindings: {
            visible: "isZipDownloadConfirmPopupVisible",
          },
        },
      ]}
      onTitleRendered={(e) => {
        e.component.registerKeyHandler("escape", function(arg) {
          arg.stopPropagation();
        });
      }}
      mdaeContentRender={() => {
        return (
          <MdaePopupContent>
            <div>
              <div className="mdae-standalone-label">
                Please name the zip file for the selected documents
              </div>
              <MdaeTextBox
                id=""
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_ZIP_FILE_DOWNLOAD_NAME,
                    reducerName: "documentManagementReducer",
                    widgetOptionBindings: {
                      value: "zipFileDownloadName",
                    },
                  },
                ]}
              >
                <Validator validationGroup="zipFileDownloadConfigValidationGroup">
                  <RequiredRule message="Please enter a file name." />
                </Validator>
              </MdaeTextBox>
            </div>
          </MdaePopupContent>
        );
      }}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterStartButtons>
              <MdaeButton
                id=""
                role={"secondary"}
                onClick={() => {
                  dispatch({
                    type: TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP,
                    data: {
                      isZipDownloadConfirmPopupVisible: false,
                    },
                  });
                  props.toggleDocumentGridCheckboxes();
                }}
              >
                Cancel
              </MdaeButton>
            </MdaePopupFooterStartButtons>
            <MdaePopupFooterEndButtons>
              <MdaeButton
                id=""
                validationGroup="zipFileDownloadConfigValidationGroup"
                role={"primary"}
                onClick={(e) => {
                  if (e.validationGroup.validate().isValid) {
                    dispatch({
                      type: TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP,
                      data: {
                        isZipDownloadConfirmPopupVisible: false,
                      },
                    });
                    const selectedRowsData = props.documentDataGridInstance.getSelectedRowsData();
                    props.bulkDownloadDocumentsHandler(selectedRowsData);
                  }
                }}
              >
                OK
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};
export default ZipFileDonwloaConfirmPopup;
